import invocationSummary from './invocationSummary'
import invocationServices from './invocationServices'
import userAgentCount from './userAgentCount'
import mobileDeviceCount from './mobileDeviceCount'
import tenantAlais from './tenantAlais'
import tenantCount from './tenantCount'
import averageResponseTime from './averageResponseTime'
import splashViewData from './splashViewData'
import userCount from './userCount'
import provinceCountList from './provinceCountList'
import labelCount from './labelCount'
import notificationData from './notificationData'
import averageNewWorkTime from './averageNewWorkTime'
import worldSecurityAttachCountData from './worldSecurityAttachCountData'
import latestAttachData from './latestAttachData'
import userLoginIllegalData from './userLoginIllegalData'
import netAttachCountData from './netAttachCountData'

import productCountData from './productCountData'
import rewardTeamData from './rewardTeamData'

export default {
  invocationSummary,
  invocationServices,
  userAgentCount,
  mobileDeviceCount,
  tenantAlais,
  tenantCount,
  averageResponseTime,
  splashViewData,
  userCount,
  provinceCountList,
  labelCount,
  notificationData,
  averageNewWorkTime,
  worldSecurityAttachCountData,
  latestAttachData,
  userLoginIllegalData,
  netAttachCountData,
  productCountData,
  rewardTeamData
}



// WEBPACK FOOTER //
// ./src/utils/formattings/index.js